import { render, staticRenderFns } from "./ValidateForm.vue?vue&type=template&id=2eaf8dcf&"
import script from "./ValidateForm.vue?vue&type=script&lang=js&"
export * from "./ValidateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports